import mixpanel from 'mixpanel-browser';

import { EnvironmentVariableEnum } from '../../constants/environment-variable.ts';
import { TrackingEvent } from '../../types/tracking.types.ts';

export class MixpanelTrackerUtil {
  private static _instance: MixpanelTrackerUtil;

  static get instance(): MixpanelTrackerUtil {
    if (!MixpanelTrackerUtil._instance) {
      MixpanelTrackerUtil._instance = new MixpanelTrackerUtil(EnvironmentVariableEnum.MIXPANEL_TOKEN);
    }

    return MixpanelTrackerUtil._instance;
  }

  private isInitialized = false;

  constructor(private readonly token: string) {
    this.initClient();
  }

  private initClient(): void {
    if (!this.token) {
      return;
    }

    mixpanel.init(this.token, {
      track_pageview: 'url-with-path-and-query-string',
    });
    this.isInitialized = true;
  }

  track(event: TrackingEvent): void {
    if (!this.isInitialized) {
      return;
    }

    mixpanel.track(event.event, event.data || {});
  }

  reset(): void {
    if (!this.isInitialized) {
      return;
    }

    mixpanel.reset();
  }

  identify(userId: string): void {
    if (!this.isInitialized) {
      return;
    }

    mixpanel.identify(userId);
  }

  setUserProperties(properties: Record<string, unknown>): void {
    if (!this.isInitialized) {
      return;
    }

    mixpanel.people.set(properties);
  }
}

export const getMixpanelTrackerUtil = (): MixpanelTrackerUtil => MixpanelTrackerUtil.instance;
